module.exports = __webpack_public_path__ + "img/ic-red-close.6925c4b8.svg";